export const getFormattedItemsPath = (
  itemsPath: string,
  isBranch?: boolean
) => {
  const pathSegments = itemsPath.split("/");
  const path = isBranch
    ? [
        pathSegments[1],
        pathSegments[2],
        pathSegments[3],
        pathSegments[4],
        pathSegments[5],
      ]
    : [pathSegments[1], pathSegments[2], pathSegments[3], pathSegments[4]];
  const formattedItemsPath = `/${path.join("/")}`;

  return formattedItemsPath;
};
